<template>
  <div class="fill-details">
    <div id="left-pane">
      <div class="test-details">
        <img id="image" src="../assets/fill-details.svg" alt="Fill Details" />
        <p id="sample-test">{{ $store.state.test.name }}</p>
        <table rules="rows" class="parent-test-details">
          <tr>
            <td class="test-details-left-column">By</td>
            <td class="test-details-right-column" style="color: #0988f4">
              {{ $store.state.test.companyName }}
            </td>
          </tr>
          <tr>
            <td class="test-details-left-column">Duration</td>
            <td class="test-details-right-column">
              {{ $store.getters.getDuration }} hours
            </td>
          </tr>
          <tr>
            <td class="test-details-left-column">Opens At</td>
            <td class="test-details-right-column">
              {{ $store.getters.getFormattedDate }}
            </td>
          </tr>
        </table>
      </div>
      <div class="help-section">
        <hr class="horizontal-line" />
        <div class="help-div">
          <p id="recommended">Recommended before you start test</p>
          <p id="recommended-para">
            Before taking {{ $store.state.test.name }}, it is recommended that
            you take a practice test.
          </p>
          <button
            class="practice-test"
            @click="practiceTest"
          >
            TAKE PRACTICE TEST
          </button>
          <p id="help-support">Help and support</p>
          <p class="contact-administrator">
            You can contact the test administrator at
            <a
              href="mailto:headstart-support@infocusp.com"
              target="_top"
              style="color: #319bf5"
              >headstart-support@infocusp.com</a
            >
          </p>
          <!--<p class="contact-administrator">
            OR
            <a
              href="https://meet.google.com/kbg-qghf-ody"
              target="_blank"
              style="color: #319BF5"
            >Join this link</a
            >
            to get help on video call
          </p>-->
        </div>
      </div>
    </div>
    <div class="right-pane">
      <div class="inner-white-div">
        <div>
          <p id="fill-your-details">Please fill in your basic details</p>
          <form novalidate @submit.prevent="validateBeforeSubmit">
            <table id="form-table">
              <tr class="table-row">
                <td class="form-field">Full Name</td>
                <td>
                  <input
                    v-model="full_name"
                    v-validate="'required|alpha_spaces'"
                    :class="[
                      (fields.full_name &&
                        fields.full_name.touched &&
                        fields.full_name.invalid &&
                        fields.full_name.dirty) ||
                      (isFormSubmitted &&
                        fields.full_name.pristine &&
                        errors.has('full_name'))
                        ? 'error-input'
                        : 'input-field',
                    ]"
                    type="text"
                    name="full_name"
                  />
                  <span
                    v-if="
                      (fields.full_name &&
                        fields.full_name.touched &&
                        fields.full_name.invalid &&
                        fields.full_name.dirty) ||
                        (isFormSubmitted &&
                          fields.full_name.pristine &&
                          errors.has('full_name'))
                    "
                    class="error-message"
                    >{{ errors.first('full_name') }}</span
                  >
                </td>
              </tr>
              <tr class="table-row">
                <td class="form-field">Email</td>
                <td>
                  <input
                    v-model="email"
                    v-validate="'required|email'"
                    :class="[
                      (fields.email &&
                        fields.email.touched &&
                        fields.email.invalid &&
                        fields.email.dirty) ||
                      (isFormSubmitted &&
                        fields.email.pristine &&
                        errors.has('email'))
                        ? 'error-input'
                        : 'email-input-field',
                    ]"
                    name="email"
                    disabled
                  />
                  <span
                    v-if="
                      (fields.email &&
                        fields.email.touched &&
                        fields.email.invalid &&
                        fields.email.dirty) ||
                        (isFormSubmitted &&
                          fields.email.pristine &&
                          errors.has('email'))
                    "
                    class="error-message"
                    >{{ errors.first('email') }}</span
                  >
                </td>
              </tr>
              <tr class="table-row">
                <td class="form-field">Contact Number</td>
                <td>
                  <input class="country-code" placeholder="+91" disabled />
                  <input
                    v-model="contact_number"
                    v-validate="{ required: true, regex: /^\d{10}$/ }"
                    :class="[
                      (fields.contact_number &&
                        fields.contact_number.touched &&
                        fields.contact_number.invalid &&
                        fields.contact_number.dirty) ||
                      (isFormSubmitted &&
                        fields.contact_number.pristine &&
                        errors.has('contact_number'))
                        ? 'contact-error-input'
                        : 'contact-input-field',
                    ]"
                    name="contact_number"
                    @keypress="isNumber()"
                  />
                  <span
                    v-if="
                      (fields.contact_number &&
                        fields.contact_number.touched &&
                        fields.contact_number.invalid &&
                        fields.contact_number.dirty) ||
                        (isFormSubmitted &&
                          fields.contact_number.pristine &&
                          errors.has('contact_number'))
                    "
                    class="error-message"
                    >{{ errors.first('contact_number') }}</span
                  >
                </td>
              </tr>
              <tr class="table-row">
                <td class="form-field">Roll Number</td>
                <td>
                  <input
                    v-model="roll_number"
                    :class="[
                      (fields.roll_number &&
                        fields.roll_number.touched &&
                        fields.roll_number.invalid &&
                        fields.roll_number.dirty) ||
                      (isFormSubmitted &&
                        errors.has('roll_number'))
                        ? 'error-input'
                        : 'input-field',
                    ]"
                    type="text"
                    name="roll_number" />
                  <span
                    v-if="
                      (fields.roll_number &&
                        fields.roll_number.touched &&
                        fields.roll_number.invalid &&
                        fields.roll_number.dirty) ||
                        (isFormSubmitted &&
                          errors.has('roll_number'))
                    "
                    class="error-message">
                    {{ errors.first('roll_number') }}
                  </span>
                </td>
              </tr>
              <tr class="table-row">
                <td
                  class="form-field"
                  :class="errors.has('gender') ? 'add-padding' : ''"
                >
                  Gender
                </td>
                <td>
                  <select
                    v-model="gender"
                    v-validate="'required'"
                    :class="[
                      (fields.gender &&
                        fields.gender.touched &&
                        fields.gender.invalid &&
                        fields.gender.dirty) ||
                      (isFormSubmitted &&
                        fields.gender.pristine &&
                        errors.has('gender'))
                        ? 'select-error-input'
                        : 'select-input-field',
                    ]"
                    name="gender"
                  >
                    <option class="option" value="Male">Male</option>
                    <option class="option" value="Female">Female</option>
                    <option class="option" value="Other">Other</option>
                    <option class="option" value="Choose not to Mention">
                      Choose not to Mention
                    </option>
                  </select>
                  <span
                    v-if="
                      (fields.gender &&
                        fields.gender.touched &&
                        fields.gender.invalid &&
                        fields.gender.dirty) ||
                        (isFormSubmitted &&
                          fields.gender.pristine &&
                          errors.has('gender'))
                    "
                    class="error-message"
                    >{{ errors.first('gender') }}</span
                  >
                </td>
              </tr>
              <tr class="table-row">
                <td class="form-field">College/University</td>
                <td>
                  <input
                    v-model="college"
                    v-validate="'required'"
                    :class="[
                      (fields.college &&
                        fields.college.touched &&
                        fields.college.invalid &&
                        fields.college.dirty) ||
                      (isFormSubmitted &&
                        fields.college.pristine &&
                        errors.has('college'))
                        ? 'error-input'
                        : 'input-field',
                    ]"
                    type="text"
                    name="college"
                  />
                  <span
                    v-if="
                      (fields.college &&
                        fields.college.touched &&
                        fields.college.invalid &&
                        fields.college.dirty) ||
                        (isFormSubmitted &&
                          fields.college.pristine &&
                          errors.has('college'))
                    "
                    class="error-message"
                    >{{ errors.first('college') }}</span
                  >
                </td>
              </tr>
              <tr class="table-row">
                <td class="form-field">Graduation Year</td>
                <td>
                  <select
                    v-model="graduation_year"
                    v-validate="'required'"
                    :class="[
                      (fields.graduation_year &&
                        fields.graduation_year.touched &&
                        fields.graduation_year.invalid &&
                        fields.graduation_year.dirty) ||
                      (isFormSubmitted &&
                        fields.graduation_year.pristine &&
                        errors.has('graduation_year'))
                        ? 'select-error-input'
                        : 'select-input-field',
                    ]"
                    name="graduation_year"
                  >
                    <option
                      v-for="option in options"
                      :key="option"
                      :value="option"
                    >
                      {{ option }}
                    </option>
                  </select>
                  <span
                    v-if="
                      (fields.graduation_year &&
                        fields.graduation_year.touched &&
                        fields.graduation_year.invalid &&
                        fields.graduation_year.dirty) ||
                        (isFormSubmitted &&
                          fields.graduation_year.pristine &&
                          errors.has('graduation_year'))
                    "
                    class="error-message"
                    >{{ errors.first('graduation_year') }}</span
                  >
                </td>
              </tr>
              <tr class="table-row">
                <td class="form-field">CGPA (On a Scale of 10)</td>
                <td>
                  <input
                    v-model="cgpa"
                    v-validate="{
                      regex: /^(10|\d)(\.\d{1,2})?$/,
                      min_value: 1,
                      max_value: 10,
                    }"
                    :class="[
                      (fields.cgpa &&
                        fields.cgpa.touched &&
                        fields.cgpa.invalid &&
                        fields.cgpa.dirty) ||
                      (isFormSubmitted &&
                        errors.has('cgpa'))
                        ? 'error-input'
                        : 'input-field',
                    ]"
                    name="cgpa"
                  />
                  <span
                    v-if="
                      (fields.cgpa &&
                        fields.cgpa.touched &&
                        fields.cgpa.invalid &&
                        fields.cgpa.dirty) ||
                        (isFormSubmitted &&
                          errors.has('cgpa'))
                    "
                    class="error-message"
                    >{{ errors.first('cgpa') }}</span
                  >
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <div style="display: flex; width: 100px">
                    <div style="display: flex">
                      <input
                        id="checkbox"
                        v-model="checked"
                        v-validate="'required'"
                        type="checkbox"
                        name="checkbox"
                      />
                      <p id="terms-conditions">
                        By participating in the HeadStart online assessment, I
                        agree to the
                        <a @click="openPrivacyPolicy()"
                          >Privacy Policy and Terms of Use.</a
                        >
                        <span id="checkbox-error">
                          {{ errors.first('checkbox') }}
                        </span>
                      </p>
                    </div>
                  </div>
                </td>
              </tr>
            </table>

            <div class="parent-submit-details">
              <button
                class="submit-details"
                type="submit"
              >
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api.service'
export default {
  name: 'FillDetails',
  data: function() {
    return {
      full_name: null,
      email: null,
      contact_number: null,
      roll_number: null,
      gender: null,
      college: null,
      graduation_year: null,
      cgpa: null,
      resp: {},
      url: '',
      currentYear: '',
      options: [],
      Agreed: true,
      checked: false,
      isFormSubmitted: false,
      test_id: '',
      test_name: 'Sample Test',
      test_owner: 'Infocusp Innovations Pvt. Ltd.',
      test_duration: '1:30:00 mins',
      test_time: '17 Dec,2018  1:15 pm',
      testee_status: '',
    }
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    if(this.$store.state.currentStep !== 'fill-details') {
      var testId = this.$route.params.test_id
      var userId = this.$route.params.user_id
      this.$store.commit('setCurrentStep', 'webcam')
      this.$router.replace({ path: `/webcam/test/${testId}/user/${userId}` })
      return;
    }
    this.email = atob(this.$route.params.user_id)
    this.currentYear = new Date().getFullYear()
    var i = this.currentYear - 60
    var j = this.currentYear + 2
    var x
    for (x = j; x >= i; x--) {
      this.options.push(x)
    }
    const dict = {
      custom: {
        full_name: {
          required: 'Full name is required',
          alpha_spaces: 'This is not a valid name',
        },
        email: {
          required: 'Email address is required',
          email: 'This is not a valid email address',
        },
        contact_number: {
          required: 'Contact number is required',
          regex: 'This is not a valid contact number',
        },
        roll_number: {
          required: 'Roll number is required',
        },
        gender: {
          required: 'Gender is required',
        },
        college: {
          required: 'College/University is required',
        },
        graduation_year: {
          required: 'Graduation year is required',
          regex: 'This is not a valid graduation year',
        },
        cgpa: {
          required: 'CGPA is required',
        },
        checkbox: {
          required: 'Please agree with the terms and conditions',
        },
      },
    }
    this.$validator.localize('en', dict)
    this.fetchData()

    if (typeof this.$store.state.test.startDateTime === 'string') {
      this.$store.commit(
        'setStartDateTime',
        new Date(this.$store.state.test.startDateTime)
      )
    }
  },
  methods: {
    fetchData() {
      var self = this
      // this.email = this.$route.params.user_id
      this.$store.commit('setUserEmail', this.email)
      api
        .getCandidate(this.$store.state.userEmail)
        .then(function(response) {
          self.resp = response
          self.$store.state.userId = self.resp.id //issue here
          self.full_name = self.resp.full_name
          self.email = self.resp.email
          self.contact_number = self.resp.contact_number
          self.roll_number = self.resp.roll_number
          self.gender = self.resp.gender
          self.cgpa = self.resp.cgpa === -1 ? "" : self.resp.cgpa
          self.college = self.resp.college
          self.graduation_year = self.resp.graduation_year
        })
        .catch(function(error) {
          self.resp = ''
          self.full_name = ''
          self.contact_number = ''
          self.roll_number = ''
          self.gender = ''
          self.cgpa = ''
          self.college = ''
          self.graduation_year = ''
        })
    },
    openPrivacyPolicy() {
      let routeData = this.$router.resolve({ name: 'privacy-policy' })
      window.open(routeData.href, '_blank')
    },
    isNumber: function(evt) {
      evt = evt || window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    validateBeforeSubmit() {
      var self = this
      this.$validator.validateAll().then(result => {
        console.log(this.$validator.errors.first('checkbox'))
        if (result) {
          var candidate = {}
          candidate['full_name'] = this.full_name
          candidate['email'] = this.email
          candidate['contact_number'] = this.contact_number
          candidate['roll_number'] = this.roll_number
          candidate['gender'] = this.gender
          candidate['college'] = this.college
          candidate['graduation_year'] = this.graduation_year
          candidate['cgpa'] = this.cgpa ? this.cgpa : -1
          candidate['test_id'] = this.$route.params.test_id

          api
            .postCandidate(candidate)
            .then(function(response) {
              self.$store.commit('setUserId', response.id)
              self.navigateToNextPage()
            })
            .catch(function(error) {
              console.log(error)
          })
        } else {
          this.isFormSubmitted = true
        }
      })
    },
    navigateToNextPage() {
      if (!sessionStorage.totalTime) {
        sessionStorage.totalTime = 60
      }
      this.$store.commit('setCurrentStep', 'read-instructions')
      var testId = this.$route.params.test_id
      var userId = this.$route.params.user_id
      this.$router.replace({ path: `/read-instructions/test/${testId}/user/${userId}` })
    },
    practiceTest: function() {
      window.open('https://headstart.infocusp.com/#/practice-test', '_blank')
    },
  },
}
</script>
<style scoped>

.fill-details {
  display: flex;
  margin-top: 64px;
  flex: 1;
  max-height: calc(100% - 64px);
}

#left-pane {
  background: #ffffff;
  /*box-shadow: inset -1px 0 0 0 #a8b2c6;*/
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: 376px;
  overflow-y: auto;
}

#image {
  display: block;
  margin: 24px auto;
  height: 200px;
  width: 216px;
}

.test-details-right-column {
  font-family: Roboto-Medium;
  color: #9b9b9b;
  letter-spacing: 0;
  padding: 16px 0;
}

.test-details-left-column {
  font-family: Roboto-Regular;
  color: #9b9b9b;
  letter-spacing: 0;
  padding: 0 32px;
}

.parent-test-details {
  border: none;
  margin-right: 32px;
  width: 326px;
}

.parent-test-details tr {
  border-top: solid thin;
  border-bottom: solid thin;
  border-color: #efeef3;
}

.practice-test {
  padding: 4px;
  border: 1px solid #1bc09c;
  border-radius: 2px;
  background-color: white;
  color: #1bc09c;
  text-align: center;
  font-size: 12px;
  height: 30px;
  outline: #1bc09c;
  font-family: Roboto-Bold;
}

.practice-test:hover {
  background: #1bc09c;
  box-shadow: 0 10px 20px 0 rgba(27, 192, 156, 0.4);
  color: #f2f2f2;
  outline: #1bc09c;
  cursor: pointer;
}

.practice-test:active {
  background: #1bc09c;
  border: 1px solid #1bc09c;
  color: white;
  outline: #1bc09c;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.horizontal-line {
  width: 326px;
  border: 0.5px solid #efeef3;
  padding-left: 18px;
  margin-right: 30px;
  margin-bottom: 8px;
}

.help-div {
  padding: 0px 32px;
  font-family: Roboto-Bold;
  letter-spacing: 0;
  font-size: 14px;
  margin-bottom: 42px;
}

.help-section {
  margin-top: auto;
}

.contact-administrator {
  font-family: Roboto-Regular;
  color: #9b9b9b;
  line-height: 20px;
}

#help-support {
  margin-top: 24px;
  font-family: Roboto-Bold;
  color: #616262;
  letter-spacing: 0;
}

#recommended-para {
  margin-top: 8px;
  color: #9b9b9b;
  line-height: 20px;
  font-family: Roboto-Regular;
}

#recommended {
  color: #616262;
}

.inner-white-div {
  flex: 1;
  margin-left: 16px;
  background: #ffffff;
  border-radius: 2px;
}

#checkbox-error {
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #f66957;
  letter-spacing: 0;
  line-height: 20px;
  display: block;
}

#terms-conditions {
  font-family: Roboto-Regular;
  flex: 1;
  font-size: 14px;
  color: #9b9b9b;
  letter-spacing: 0;
  line-height: 20px;
  height: 64px;
  text-align: justify;
  margin: 0 0 0 16px;
  width: 450px;
}

.error-message {
  width: 224px;
  height: 20px;
  margin-top: 6px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #f66957;
  letter-spacing: 0;
  line-height: 20px;
  display: block;
}

.error-class {
  display: block;
  margin-top: 6px;
}

.form-field {
  font-family: Roboto-Regular;
  color: #616262;
  letter-spacing: 0;
  vertical-align: top;
  padding-top: 10px;
  height: 28px;
}

#fill-your-details {
  font-family: Roboto-Light;
  font-size: 24px;
  color: #616262;
  letter-spacing: 0;
  padding-top: 42px;
}

#checkbox {
  height: 18px;
  width: 18px;
  background-color: #319bf5;
  border-radius: 2px;
}

#form-table {
  text-align: left;
  border-spacing: 16px 24px;
  margin: 0 auto;
}

.error-input {
  padding: 0px 20px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #f66957;
  letter-spacing: 0;
  background: #ffffff;
  border: 1px solid #f66957;
  border-radius: 2px;
  width: 297px;
  height: 32px;
}

.select-error-input {
  padding: 0px 20px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #f66957;
  letter-spacing: 0;
  background: #ffffff;
  border: 1px solid #f66957;
  border-radius: 2px;
  width: 297px;
  height: 34px;
}

.contact-error-input {
  padding: 0px 20px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #f66957;
  letter-spacing: 0;
  background: #ffffff;
  border: 1px solid #f66957;
  border-radius: 2px;
  width: 249px;
  height: 32px;
}
.select-input-field {
  width: 297px;
  height: 36px;
  padding: 0 10px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #616262;
  letter-spacing: 0;
  background: #ffffff;
  border: 2px solid rgba(155, 155, 155, 0.2);
  border-radius: 3px;
  -webkit-appearance: menulist;
}

.country-code {
  padding-left: 12px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #616262;
  letter-spacing: 0;
  background: #ffffff;
  border: 2px solid rgba(155, 155, 155, 0.2);
  border-radius: 3px;
  width: 48px;
  height: 32px;
  margin-right: 3px;
}

.error-country-code {
  padding-left: 8px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #f66957;
  letter-spacing: 0;
  background: #ffffff;
  border: 1px solid #f66957;
  border-radius: 2px;
  width: 44px;
  height: 32px;
  margin-right: 3px;
}
.input-field {
  padding: 0 12px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #616262;
  letter-spacing: 0;
  background: #ffffff;
  border: 2px solid rgba(155, 155, 155, 0.2);
  border-radius: 3px;
  width: 297px;
  height: 32px;
}
.input-field:focus,
.contact-input-field:focus,
.select-input-field:active {
  border-width: 1px;
  border-color: #0988f4;
}
.contact-input-field {
  padding: 0 12px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #616262;
  letter-spacing: 0;
  background: #ffffff;
  border: 2px solid rgba(155, 155, 155, 0.2);
  border-radius: 3px;
  width: 249px;
  height: 32px;
}
.email-input-field {
  padding: 0 12px;
  background: #eeeeee;
  border: 2px solid rgba(155, 155, 155, 0.2);
  border-radius: 3px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #9b9b9b;
  width: 297px;
  height: 32px;
  letter-spacing: 0;
}

.parent-submit-details {
  margin: 0 auto 42px auto;
}

.submit-details {
  border: 1px solid #0988f4;
  font-family: Roboto-Bold;
  color: #0988f4;
  text-align: center;
  background-color: #ffffff;
  padding: 10px 50px;
  font-size: 16px;
  height: 40px;
  width: 170px;
  border-radius: 2px;
  outline: #0988f4;
  cursor: pointer;
}

.submit-details:hover {
  background: #319bf5;
  box-shadow: 0 10px 20px 0 rgba(49, 155, 245, 0.4);
  color: white;
}

.submit-details:active {
  background: #0988f4;
  color: white;
  -webkit-box-shadow: none;
  box-shadow: none;
}
#firstpage {
  background-color: #dcdcdc;
  font-family: Roboto;
}

.right-pane {
  display: flex;
  flex: 1;
  text-align: center;
  background: #f2f2f2;
  color: #69758b;
  height: 100%;
  overflow-y: auto;
  flex-direction: column;
}

#sample-test {
  font-family: Roboto-Medium;
  font-size: 21px;
  color: #616262;
  letter-spacing: 0;
  margin-left: 32px;
}

input:-webkit-autofill {
  border: 2px solid #dcdcdc;
  -webkit-box-shadow: inset 0 0 0px 9999px white;
}

input:focus,
input:-webkit-autofill:focus {
  outline: none;
}
select:focus,
select:-webkit-autofill:focus {
  outline: none;
}
select *.option:hover {
  background: #f2f2f2;
}

#terms-conditions a {
  color: #0988f4;
  text-decoration: underline;
}

#terms-conditions a:hover {
  cursor: pointer;
  text-decoration: underline;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #ada2a2;
}
#left-pane::-webkit-scrollbar-thumb {
  background-color: #d0d0d0;
}
@media only screen and (max-width: 1440px) {
  #left-pane {
    overflow-y: auto;
    max-width: 280px;
  }
  /*.inner-white-div {
    margin-left: 16px;
  }*/
  #fill-your-details {
    font-size: 18px;
    /*padding-top: 16px;*/
  }
  #image {
    margin: 16px auto;
    height: 150px;
  }
  .test-details-left-column {
    padding: 0px 16px;
    font-size: 13px;
  }

  .test-details-right-column {
    font-size: 13px;
    padding: 8px 0;
    min-width: 170px;
  }
  .horizontal-line {
    display: none;
    width: 240px;
  }
  .form-field {
    font-size: 14px;
  }
  .parent-test-details {
    margin-right: 17px;
    width: 280px;
  }
  #terms-conditions {
    font-size: 13px;
  }

  .error-message {
    font-size: 12px;
  }

  #checkbox-error {
    font-size: 12px;
  }
  .parent-submit-details {
    margin: 0 auto 24px auto;
  }
  .help-div {
    padding: 0px 16px;
    margin-bottom: 24px;
    font-size: 13px;
  }
  #form-table {
    border-spacing: 16px 20px;
  }
  #sample-test {
    margin: 0 0 8px 32px;
    font-size: 18px;
  }
  #help-support {
    margin: 14px 0 8px 0;
  }
  #recommended {
    margin-bottom: 8px;
  }
  .contact-administrator,
  #recommended-para {
    margin-top: 8px;
  }
}
</style>
